import React from 'react'
import {Nav, Tab} from 'react-bootstrap';

import '../AdminPricingSettings.scss'
import { Badge } from 'reactstrap';
import PricingLayout from './PricingLayout';

const PricingSheetStructure =() =>{
  return(
    <div className="pricingoptions-container">
      <Tab.Container defaultActiveKey="standardPricingOptions" >
        <Nav className="pricing-options" variant="pills" defaultActiveKey="standardPricingOptions">
          <Nav.Item className="pricingSheetOptions">
            <Nav.Link  eventKey="standardPricingOptions"> <Badge color="dark" pill>1</Badge> <span>Standard Pricing Options</span></Nav.Link>
          </Nav.Item>
          <Nav.Item  className="pricingSheetOptions">
            <Nav.Link  eventKey="additionalPricingOptions"><Badge color="dark" pill>2</Badge> Customized Pricing Options</Nav.Link>
          </Nav.Item>
        </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="standardPricingOptions">
            <PricingLayout type='standard'></PricingLayout>

        </Tab.Pane>
        <Tab.Pane eventKey="additionalPricingOptions">
            <PricingLayout type='custom'></PricingLayout>

        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
    </div>
  )
}

export default PricingSheetStructure